import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Copy } from '../../stateless/copy';
import { NextButton } from '../../stateless/buttons';
import HOCNextStepController from '../../hoc/next-step-controller';
import ReviewResultsPlainText from '../../shared/review-results-plain-text';
import FinalScore from '../../stateless/final-score';

const EnhancedButton = HOCNextStepController(NextButton);

export default class PlainText extends Component {

	static PropTypes = {
		user: PropTypes.object,
		players: PropTypes.object,
		window: PropTypes.object,
		nextWindow: PropTypes.func,
		countryCode: PropTypes.string
	};

	constructor (props) {
		super(props);

		this.hasResources = true;
	}

	componentDidMount () {
		this.additionalResources();
	}

	additionalResources () {
		const { window: { current } } = this.props;
		const newState = {};

		for (const player in current.playerBaseResources) {
			newState[player] = { resources: current.playerBaseResources[player] };
		}

		this.hasResources = true;
		this.props.updateSaveState({ players: newState });
	}

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		const { window, user, countryCode, players } = this.props;
		return (
			<div>
				<Copy
					user={user}
					window={window}
					countryCode={countryCode}
					players={players}
				>
					{
						(window.current && window.current.reviewResults && window.current.playerBaseResources) &&
						<ReviewResultsPlainText playersResults={window.current.playerBaseResources} />
					}

					{
						(window.current && window.current.hasFinalScore) &&
						<FinalScore />
					}
					<EnhancedButton
						{ ...this.props }
						hasResources={ this.hasResources }
					/>
				</Copy>
			</div>
		)
	}
}
